export default "__VITE_ASSET__BUJ_VSE3__"